(function () {
  'use strict';

  var STORAGE_KEY = 'unicare-quote-v1';
  var SAVED_QUOTES_STORAGE_KEY = 'unicare-saved-quotes-v2';
  var LEGACY_ACTIVE_QUOTE_STORAGE_KEY = 'unicare-active-quote-v1';
  var HANDOFF_STORAGE_KEY = 'unicare-quote-handoff-v1';
  var CHECKOUT_PENDING_STORAGE_KEY = 'unicare-approved-checkout-pending-v1';
  var drawer = document.querySelector('[data-quote-drawer]');

  if (!drawer) return;

  var overlay = document.querySelector('[data-quote-overlay]');
  var drawerBody = drawer.querySelector('.quote-drawer__body');
  var itemsContainer = drawer.querySelector('[data-quote-items]');
  var emptyState = drawer.querySelector('[data-quote-empty]');
  var actions = drawer.querySelector('[data-quote-actions]');
  var formPanel = drawer.querySelector('[data-quote-form-panel]');
  var quoteContent = drawer.querySelector('[data-quote-content]');
  var successPanel = drawer.querySelector('[data-quote-success]');
  var quoteForm = drawer.querySelector('.quote-request-form');
  var quoteIdCreateButton = drawer.querySelector('[data-quote-id-create]');
  var quoteIdStatus = drawer.querySelector('[data-quote-id-status]');
  var handoffStepNodes = drawer.querySelectorAll('[data-quote-handoff-step]');
  var handoffCopyButton = drawer.querySelector('[data-quote-handoff-copy]');
  var handoffDoneButton = drawer.querySelector('[data-quote-handoff-done]');
  var handoffQuoteIdNode = drawer.querySelector('[data-quote-handoff-id]');
  var savedQuotesSection = drawer.querySelector('[data-saved-quotes]');
  var savedQuotesList = drawer.querySelector('[data-saved-quotes-list]');
  var clearListButton = drawer.querySelector('[data-quote-clear]');
  var approvedQuotesJump = drawer.querySelector('[data-approved-quotes-jump]');
  var announcer = document.querySelector('[data-quote-announcer]');
  var messengerDemo = document.querySelector('[data-messenger-demo]');
  var messengerDemoPanel = messengerDemo && messengerDemo.querySelector('[data-messenger-demo-panel]');
  var messengerDemoToggle = messengerDemo && messengerDemo.querySelector('[data-messenger-demo-toggle]');
  var messengerDemoStatus = messengerDemo && messengerDemo.querySelector('[data-messenger-demo-status]');
  var lastFocusedElement = null;
  var messengerDemoLastFocus = null;
  var messengerDemoReference = null;
  var formMode = false;
  var successMode = false;
  var savedQuotes = loadSavedQuotes();
  var activeHandoff = loadActiveHandoff();
  var items = loadItems();
  var quoteApiUrl = String(drawer.getAttribute('data-quote-api-url') || '').replace(/\/+$/, '');
  var quoteIdHandoffEnabled = drawer.getAttribute('data-quote-id-handoff-enabled') === 'true';
  var quoteMessengerUrl = safeMessengerRedirect(drawer.getAttribute('data-quote-messenger-url'));
  var messengerIntegrationEnabled = drawer.getAttribute('data-quote-messenger-enabled') === 'true' && /^https:\/\//i.test(quoteApiUrl);
  var pricingUnlocked = drawer.getAttribute('data-pricing-unlocked') === 'true';
  var clientRequestId = null;
  var quoteStatusCheckInFlight = false;
  var lastQuoteStatusCheckAt = 0;
  var approvedCheckoutInFlight = '';

  function pendingCheckoutQuoteId() {
    try {
      var pending = JSON.parse(window.localStorage.getItem(CHECKOUT_PENDING_STORAGE_KEY));
      var startedAt = parseInt(pending && pending.startedAt, 10) || 0;
      if (!pending || !validQuoteId(pending.quoteId) || startedAt <= 0 || Date.now() - startedAt > 86400000) {
        window.localStorage.removeItem(CHECKOUT_PENDING_STORAGE_KEY);
        return '';
      }
      return String(pending.quoteId).toUpperCase();
    } catch (error) {
      return '';
    }
  }

  function rememberPendingCheckout(quoteId) {
    try {
      window.localStorage.setItem(CHECKOUT_PENDING_STORAGE_KEY, JSON.stringify({
        quoteId: String(quoteId || '').toUpperCase(),
        startedAt: Date.now()
      }));
    } catch (error) {}
  }

  function clearPendingCheckout(quoteId) {
    if (!quoteId || pendingCheckoutQuoteId() === String(quoteId).toUpperCase()) {
      try { window.localStorage.removeItem(CHECKOUT_PENDING_STORAGE_KEY); } catch (error) {}
    }
  }

  function validQuoteId(value) {
    return /^UQ-\d{8}-[A-Z0-9]{5,12}$/i.test(String(value || ''));
  }

  function validClientRequestId(value) {
    return /^[A-Za-z0-9._:-]{8,100}$/.test(String(value || ''));
  }

  function loadActiveHandoff() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(HANDOFF_STORAGE_KEY));
      if (!stored || !validQuoteId(stored.quoteId)) return null;

      return {
        quoteId: String(stored.quoteId).toUpperCase(),
        step: parseInt(stored.step, 10) === 3 ? 3 : 2
      };
    } catch (error) {
      return null;
    }
  }

  function saveActiveHandoff() {
    try {
      if (activeHandoff) {
        window.localStorage.setItem(HANDOFF_STORAGE_KEY, JSON.stringify(activeHandoff));
      } else {
        window.localStorage.removeItem(HANDOFF_STORAGE_KEY);
      }
    } catch (error) {}
  }

  function sanitizeStoredItems(stored) {
    if (!Array.isArray(stored)) return [];

    return stored.filter(function (item) {
      if (!item || !item.productTitle) return false;
      if (item.type === 'custom') return /^custom:[A-Za-z0-9-]+$/.test(String(item.itemKey || ''));
      return /^\d+$/.test(String(item.variantId));
    }).map(function (item) {
      var type = item.type === 'custom' ? 'custom' : 'shopify_variant';
      var variantId = type === 'custom' ? '' : String(item.variantId || '');

      return {
        type: type,
        itemKey: type === 'custom' ? String(item.itemKey || '') : 'variant:' + variantId,
        productId: type === 'custom' ? '' : String(item.productId || item.variantId || ''),
        productTitle: String(item.productTitle || ''),
        variantId: variantId,
        variantTitle: type === 'custom' ? '' : String(item.variantTitle || ''),
        sku: String(item.sku || ''),
        url: type === 'custom' ? '/collections/all' : normalizeProductPath(item.url || item.productUrl),
        image: type === 'custom' ? '' : safeImageUrl(item.image || item.imageUrl),
        quantity: clampQuantity(item.quantity)
      };
    });
  }

  function loadItems() {
    try {
      return sanitizeStoredItems(JSON.parse(window.localStorage.getItem(STORAGE_KEY)));
    } catch (error) {
      return [];
    }
  }

  function normalizeSavedQuote(stored) {
    if (!stored || !validQuoteId(stored.quoteId) || !validClientRequestId(stored.clientRequestId)) return null;

    return {
      quoteId: String(stored.quoteId).toUpperCase(),
      clientRequestId: String(stored.clientRequestId),
      status: String(stored.status || 'pending_staff_review'),
      revision: Math.max(0, parseInt(stored.revision, 10) || 0),
      items: sanitizeStoredItems(stored.items),
      changes: Array.isArray(stored.changes) ? stored.changes : [],
      staffNote: String(stored.staffNote || ''),
      approvedAt: String(stored.approvedAt || ''),
      approvalToken: String(stored.approvalToken || ''),
      checkoutUrl: stored.status === 'approved' ? (safeCheckoutUrl(stored.checkoutUrl) || '') : ''
    };
  }

  function loadSavedQuotes() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(SAVED_QUOTES_STORAGE_KEY));
      var quotes = Array.isArray(stored) ? stored.map(normalizeSavedQuote).filter(Boolean) : [];
      var legacy = normalizeSavedQuote(JSON.parse(window.localStorage.getItem(LEGACY_ACTIVE_QUOTE_STORAGE_KEY)));

      if (legacy && !quotes.some(function (quote) { return quote.quoteId === legacy.quoteId; })) {
        quotes.unshift(legacy);
        window.localStorage.setItem(SAVED_QUOTES_STORAGE_KEY, JSON.stringify(quotes));
        window.localStorage.removeItem(STORAGE_KEY);
      }
      window.localStorage.removeItem(LEGACY_ACTIVE_QUOTE_STORAGE_KEY);
      window.sessionStorage.removeItem('unicare-last-quote');
      return quotes;
    } catch (error) {
      return [];
    }
  }

  function saveItems() {
    clientRequestId = null;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      announce('Your quote was updated for this page, but could not be saved in this browser.');
    }
  }

  function saveSavedQuotes() {
    try {
      window.localStorage.setItem(SAVED_QUOTES_STORAGE_KEY, JSON.stringify(savedQuotes));
    } catch (error) {
      announce('The quote is available on this page, but this browser could not save its ID for later.');
    }
  }

  function upsertSavedQuote(data, requestId, fallbackItems) {
    var existing = savedQuotes.find(function (quote) {
      return quote.quoteId === String(data.quoteId || '').toUpperCase();
    });
    var normalized = normalizeSavedQuote({
      quoteId: data.quoteId,
      clientRequestId: requestId || (existing && existing.clientRequestId),
      status: data.status || (existing && existing.status),
      revision: data.revision == null ? (existing && existing.revision) : data.revision,
      items: data.items || (existing && existing.items) || fallbackItems || [],
      changes: data.changes || [],
      staffNote: data.staffNote || '',
      approvedAt: data.approvedAt || '',
      approvalToken: data.approvalToken || '',
      checkoutUrl: Object.prototype.hasOwnProperty.call(data, 'checkoutUrl')
        ? (safeCheckoutUrl(data.checkoutUrl) || '')
        : ((existing && existing.checkoutUrl) || '')
    });
    if (!normalized) return null;

    savedQuotes = savedQuotes.filter(function (quote) { return quote.quoteId !== normalized.quoteId; });
    savedQuotes.unshift(normalized);
    saveSavedQuotes();
    return normalized;
  }

  function removeSavedQuote(quoteId) {
    savedQuotes = savedQuotes.filter(function (quote) { return quote.quoteId !== quoteId; });
    saveSavedQuotes();
  }

  function clampQuantity(value) {
    var quantity = parseInt(value, 10);
    if (isNaN(quantity) || quantity < 1) return 1;
    return Math.min(quantity, 999);
  }

  function itemIdentity(item) {
    if (item && item.type === 'custom') return String(item.itemKey || '');
    return 'variant:' + String(item && item.variantId || '');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeProductUrl(value) {
    return String(value || '').charAt(0) === '/' ? String(value) : '/collections/all';
  }

  function normalizeProductPath(value) {
    value = String(value || '');
    if (value.charAt(0) === '/') return value;

    try {
      var url = new URL(value);
      return url.pathname + url.search;
    } catch (error) {
      return '/collections/all';
    }
  }

  function safeImageUrl(value) {
    value = String(value || '');
    if (value.indexOf('//') === 0) return window.location.protocol + value;
    if (/^https?:\/\//i.test(value) || value.charAt(0) === '/') return value;
    return '';
  }

  function displayVariantTitle(value) {
    return value && value !== 'Default Title' ? value : '';
  }

  function totalQuantity() {
    return items.reduce(function (total, item) {
      return total + clampQuantity(item.quantity);
    }, 0);
  }

  function renderItems() {
    var itemMarkup = items.map(function (item) {
      var image = safeImageUrl(item.image);
      var variantTitle = displayVariantTitle(item.variantTitle);
      var details = [];

      if (variantTitle) details.push('<span>' + escapeHtml(variantTitle) + '</span>');
      if (item.sku) details.push('<span>SKU: ' + escapeHtml(item.sku) + '</span>');

      var identity = itemIdentity(item);

      return '<article class="quote-item" role="listitem" data-quote-item="' + escapeHtml(identity) + '">' +
        '<a class="quote-item__image" href="' + escapeHtml(safeProductUrl(item.url)) + '">' +
          (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy" width="84" height="84">' : '<span aria-hidden="true">+</span>') +
        '</a>' +
        '<div class="quote-item__details">' +
          '<a class="quote-item__title" href="' + escapeHtml(safeProductUrl(item.url)) + '">' + escapeHtml(item.productTitle) + '</a>' +
          (details.length ? '<div class="quote-item__meta">' + details.join('') + '</div>' : '') +
          '<div class="quote-item__controls">' +
            '<div class="quote-quantity" aria-label="Quantity">' +
              '<button type="button" data-quote-decrease="' + escapeHtml(identity) + '" aria-label="Decrease quantity">&minus;</button>' +
              '<input type="number" min="1" max="999" inputmode="numeric" value="' + clampQuantity(item.quantity) + '" data-quote-item-quantity="' + escapeHtml(identity) + '" aria-label="Quantity for ' + escapeHtml(item.productTitle) + '">' +
              '<button type="button" data-quote-increase="' + escapeHtml(identity) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="quote-item__remove" data-quote-remove="' + escapeHtml(identity) + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');

    itemsContainer.innerHTML = itemMarkup;

    document.querySelectorAll('[data-quote-count]').forEach(function (count) {
      count.textContent = totalQuantity();
      count.classList.toggle('hidden-count', items.length === 0);
    });

    renderSavedQuotes();
    applyPanelState();
    renderMessengerDemo();
  }

  function applyPanelState() {
    if (successMode) {
      successPanel.hidden = false;
      quoteContent.hidden = true;
      return;
    }

    successPanel.hidden = true;
    quoteContent.hidden = false;
    formPanel.hidden = !formMode;
    itemsContainer.hidden = formMode;
    emptyState.hidden = formMode || items.length > 0 || Boolean(activeHandoff);
    actions.hidden = formMode || (items.length === 0 && !activeHandoff);
  }

  function renderHandoffSteps() {
    if (!handoffStepNodes.length) return;

    if (activeHandoff && !savedQuotes.some(function (quote) { return quote.quoteId === activeHandoff.quoteId; })) {
      activeHandoff = null;
      saveActiveHandoff();
    }

    var currentStep = activeHandoff ? activeHandoff.step : 1;
    handoffStepNodes.forEach(function (stepNode) {
      var step = parseInt(stepNode.getAttribute('data-quote-handoff-step'), 10);
      var marker = stepNode.querySelector('[data-quote-handoff-marker]');
      var action = stepNode.querySelector('[data-quote-handoff-action]');
      var completed = step < currentStep;
      var active = step === currentStep;

      stepNode.classList.toggle('is-complete', completed);
      stepNode.classList.toggle('is-active', active);
      stepNode.classList.toggle('is-upcoming', step > currentStep);
      if (active) stepNode.setAttribute('aria-current', 'step');
      else stepNode.removeAttribute('aria-current');
      if (marker) marker.textContent = completed ? '✓' : String(step);
      if (action) action.hidden = !active;
    });

    if (handoffQuoteIdNode) {
      handoffQuoteIdNode.textContent = activeHandoff ? activeHandoff.quoteId : 'your quote ID';
    }
    if (quoteIdCreateButton && currentStep === 1) {
      quoteIdCreateButton.hidden = false;
      quoteIdCreateButton.disabled = false;
      quoteIdCreateButton.textContent = 'Create quote ID';
    }
    if (handoffCopyButton) handoffCopyButton.disabled = false;
    if (handoffDoneButton) handoffDoneButton.disabled = false;
  }

  function renderSavedQuotes() {
    if (clearListButton) clearListButton.hidden = items.length === 0;
    renderHandoffSteps();
    if (!savedQuotesSection || !savedQuotesList) return;

    var displayedQuotes = savedQuotes.slice().sort(function (first, second) {
      var firstApproved = first.status === 'approved' ? 1 : 0;
      var secondApproved = second.status === 'approved' ? 1 : 0;
      return secondApproved - firstApproved;
    });
    var approvedCount = displayedQuotes.filter(function (quote) { return quote.status === 'approved'; }).length;

    savedQuotesSection.hidden = savedQuotes.length === 0 || Boolean(activeHandoff);
    savedQuotesSection.classList.toggle('has-approved-quote', approvedCount > 0);
    savedQuotesList.innerHTML = displayedQuotes.map(savedQuoteMarkup).join('');
    if (approvedQuotesJump) {
      approvedQuotesJump.hidden = approvedCount === 0;
      var approvedCountNode = approvedQuotesJump.querySelector('[data-approved-quotes-count]');
      var approvedLabelNode = approvedQuotesJump.querySelector('[data-approved-quotes-label]');
      if (approvedCountNode) approvedCountNode.textContent = approvedCount;
      if (approvedLabelNode) approvedLabelNode.textContent = approvedCount === 1
        ? 'approved quote ready — view checkout'
        : 'approved quotes ready — view checkout';
    }
    document.querySelectorAll('[data-quote-floating-label]').forEach(function (label) {
      label.textContent = approvedCount > 0 ? 'Cart — approved quote ready' : 'Open Cart & Quotes';
    });
  }

  function savedQuoteMarkup(quote) {
    var approved = quote.status === 'approved';
    var statusLabel = approved ? 'Approved for checkout' : 'Pending staff review';
    var itemMarkup = quote.items.map(function (item) {
      var option = displayVariantTitle(item.variantTitle);
      return '<li><strong>' + clampQuantity(item.quantity) + ' &times; ' + escapeHtml(item.productTitle) + '</strong>' +
        (option ? '<small>' + escapeHtml(option) + '</small>' : '') + '</li>';
    }).join('');
    var changesMarkup = quote.changes.length
      ? '<div class="saved-quote__changes"><h4>What Unicare changed</h4><ul>' + quote.changes.map(changeMarkup).join('') + '</ul></div>'
      : '';
    var checkoutMarkup = approved
      ? '<button type="button" class="btn btn--full saved-quote__checkout" data-quote-approved-checkout="' + escapeHtml(quote.quoteId) + '">' +
          (pricingUnlocked ? 'Checkout this approved quote' : 'Unlock pricing to checkout') + '</button>'
      : '<p class="saved-quote__pending">Checkout will appear here after Unicare staff approves this exact list.</p>';

    return '<article class="saved-quote saved-quote--' + (approved ? 'approved' : 'pending') + '" data-saved-quote="' + escapeHtml(quote.quoteId) + '">' +
      '<div class="saved-quote__header"><div><span class="saved-quote__status">' + statusLabel + '</span><strong>' + escapeHtml(quote.quoteId) + '</strong></div>' +
      '<span class="saved-quote__revision">Revision ' + quote.revision + '</span></div>' +
      checkoutMarkup +
      '<h4>Current reviewed list</h4><ul class="saved-quote__items">' + itemMarkup + '</ul>' +
      changesMarkup +
      (quote.staffNote ? '<div class="saved-quote__note"><strong>Note from Unicare</strong><p>' + escapeHtml(quote.staffNote) + '</p></div>' : '') +
      '<div class="saved-quote__actions"><button type="button" data-quote-id-revise="' + escapeHtml(quote.quoteId) + '">Modify or add items</button>' +
      '<button type="button" data-quote-id-copy="' + escapeHtml(quote.quoteId) + '">Copy ID and open Messenger</button>' +
      '<button type="button" data-quote-id-delete="' + escapeHtml(quote.quoteId) + '">Delete quote</button></div>' +
      '<p class="saved-quote__revision-help">' + (approved
        ? 'This copies the approved list into a new editable quote. The checkout-ready version stays unchanged while the new list is reviewed.'
        : 'This copies the saved list into a new editable quote so you can change it and submit a new quote ID for review.') + '</p>' +
      '<p class="saved-quote__message" data-saved-quote-message="' + escapeHtml(quote.quoteId) + '" role="status" aria-live="polite"></p>' +
      '</article>';
  }

  function changeMarkup(change) {
    var before = change && change.before ? change.before : {};
    var after = change && change.after ? change.after : {};
    var type = String(change && change.type || '');

    if (type === 'removed') {
      return '<li class="saved-quote__change saved-quote__change--removed"><strong>Removed:</strong> ' + escapeHtml(before.productTitle || 'Product') +
        ' (quantity ' + clampQuantity(before.quantity) + ')</li>';
    }
    if (type === 'added') {
      return '<li class="saved-quote__change saved-quote__change--added"><strong>Added:</strong> ' + escapeHtml(after.productTitle || 'Product') +
        ' (quantity ' + clampQuantity(after.quantity) + ')</li>';
    }

    var descriptions = [];
    if (before.quantity !== after.quantity) descriptions.push('quantity ' + clampQuantity(before.quantity) + ' → ' + clampQuantity(after.quantity));
    if (String(before.variantTitle || '') !== String(after.variantTitle || '')) descriptions.push('option updated');
    if (String(before.productTitle || '') !== String(after.productTitle || '')) descriptions.push('product name updated');
    if (String(before.sku || '') !== String(after.sku || '')) descriptions.push('SKU updated');
    if (Array.isArray(change.fields) && change.fields.indexOf('unitPrice') !== -1) descriptions.push('pricing updated');
    return '<li class="saved-quote__change saved-quote__change--modified"><strong>Modified:</strong> ' +
      escapeHtml(after.productTitle || before.productTitle || 'Product') + (descriptions.length ? ' — ' + escapeHtml(descriptions.join(', ')) : '') + '</li>';
  }

  function announce(message) {
    if (!announcer) return;
    announcer.textContent = '';
    window.setTimeout(function () {
      announcer.textContent = message;
    }, 20);
  }

  function renderMessengerDemo() {
    if (!messengerDemo) return;

    var shareButton = messengerDemo.querySelector('[data-messenger-demo-share]');
    var quoteButton = messengerDemo.querySelector('[data-messenger-demo-quote]');

    if (shareButton) {
      shareButton.hidden = items.length === 0;
      shareButton.textContent = 'Copy quote list and open Messenger';
    }

    if (quoteButton) {
      quoteButton.hidden = items.length > 0;
      quoteButton.textContent = 'Start a quote list';
    }
  }

  function openMessengerDemo(trigger) {
    if (!messengerDemoPanel || !messengerDemoToggle) return;

    messengerDemoLastFocus = trigger || document.activeElement;
    messengerDemoPanel.hidden = false;
    messengerDemoPanel.removeAttribute('inert');
    messengerDemoToggle.setAttribute('aria-expanded', 'true');
    if (messengerDemoStatus) messengerDemoStatus.textContent = '';

    var closeButton = messengerDemoPanel.querySelector('[data-messenger-demo-close]');
    if (closeButton) closeButton.focus();
  }

  function closeMessengerDemo(restoreFocus) {
    if (!messengerDemoPanel || !messengerDemoToggle || messengerDemoPanel.hidden) return;

    messengerDemoPanel.hidden = true;
    messengerDemoPanel.setAttribute('inert', '');
    messengerDemoToggle.setAttribute('aria-expanded', 'false');

    if (restoreFocus !== false && messengerDemoLastFocus && typeof messengerDemoLastFocus.focus === 'function') {
      messengerDemoLastFocus.focus();
    }
  }

  function toggleMessengerDemo(trigger) {
    if (!messengerDemoPanel) return;
    if (messengerDemoPanel.hidden) {
      openMessengerDemo(trigger);
    } else {
      closeMessengerDemo();
    }
  }

  function openDrawer(trigger) {
    closeMessengerDemo(false);
    lastFocusedElement = trigger || document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    drawer.classList.add('is-open');
    overlay.hidden = false;
    window.requestAnimationFrame(function () {
      overlay.classList.add('is-open');
    });
    document.body.classList.add('quote-drawer-open');

    if (drawerBody) drawerBody.scrollTop = 0;

    var focusTarget = successMode ? successPanel : drawer.querySelector('[data-quote-close]');
    if (focusTarget) focusTarget.focus();
    reconcileSavedQuotes(false);
  }

  // The legacy navigation can consume clicks before this script's delegated
  // click handler runs. The inline capture handler calls this bridge instead.
  window.UnicareQuoteCartOpen = openDrawer;

  function jumpToApprovedCheckout(event) {
    event.preventDefault();
    var checkoutButton = drawer.querySelector('[data-quote-approved-checkout]');
    if (!checkoutButton) {
      lastQuoteStatusCheckAt = 0;
      reconcileSavedQuotes(true);
      return;
    }
    var approvedCard = checkoutButton.closest('[data-saved-quote]');
    if (approvedCard && typeof approvedCard.scrollIntoView === 'function') approvedCard.scrollIntoView({ block: 'start' });
    checkoutButton.focus();
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('quote-drawer-open');
    if (window.location.hash === '#QuoteDrawer' && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    window.setTimeout(function () {
      overlay.hidden = true;
    }, 220);

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function itemFromButton(button) {
    var productForm = button.closest('[data-quote-product-form]');
    if (!productForm) return null;

    var variantSelect = productForm.querySelector('[data-quote-variant]');
    var quantityInput = productForm.querySelector('[data-quote-quantity]');
    var selectedOption = variantSelect && variantSelect.options[variantSelect.selectedIndex];

    if (!selectedOption || !/^\d+$/.test(selectedOption.value)) return null;

    return {
      productId: String(productForm.getAttribute('data-product-id') || ''),
      productTitle: String(productForm.getAttribute('data-product-title') || ''),
      variantId: String(selectedOption.value),
      variantTitle: String(selectedOption.getAttribute('data-variant-title') || ''),
      sku: String(selectedOption.getAttribute('data-sku') || ''),
      url: safeProductUrl(productForm.getAttribute('data-product-url')),
      image: safeImageUrl(productForm.getAttribute('data-product-image')),
      quantity: clampQuantity(quantityInput ? quantityInput.value : 1)
    };
  }

  function addItem(button) {
    var newItem = itemFromButton(button);
    if (!newItem) {
      announce('Please choose an available product option.');
      return;
    }

    var existingItem = items.find(function (item) {
      return String(item.variantId) === newItem.variantId;
    });

    if (existingItem) {
      existingItem.quantity = clampQuantity(existingItem.quantity + newItem.quantity);
    } else {
      items.push(newItem);
    }

    saveItems();
    renderItems();

    var productForm = button.closest('[data-quote-product-form]');
    var status = productForm && productForm.querySelector('[data-quote-add-status]');
    var message = newItem.productTitle + ' was added to your quote.';
    if (status) status.textContent = message;
    announce(message);

    button.classList.add('is-added');
    window.setTimeout(function () {
      button.classList.remove('is-added');
    }, 700);
  }

  function findItem(variantId) {
    return items.find(function (item) {
      return itemIdentity(item) === String(variantId);
    });
  }

  function changeQuantity(variantId, amount) {
    var item = findItem(variantId);
    if (!item) return;
    item.quantity = clampQuantity(item.quantity + amount);
    saveItems();
    renderItems();
    announce('Quantity updated.');
  }

  function changeProductQuantity(button, amount) {
    var productForm = button.closest('[data-quote-product-form]');
    var quantityInput = productForm && productForm.querySelector('[data-quote-quantity]');
    if (!quantityInput) return;

    quantityInput.value = clampQuantity(parseInt(quantityInput.value, 10) + amount);
  }

  function setQuantity(variantId, value) {
    var item = findItem(variantId);
    if (!item) return;
    item.quantity = clampQuantity(value);
    saveItems();
    renderItems();
    announce('Quantity updated.');
  }

  function removeItem(variantId) {
    var item = findItem(variantId);
    items = items.filter(function (candidate) {
      return itemIdentity(candidate) !== String(variantId);
    });
    if (items.length === 0) formMode = false;
    saveItems();
    renderItems();
    announce((item ? item.productTitle : 'Product') + ' was removed from your quote.');
  }

  function makeReference() {
    var date = new Date();
    var datePart = String(date.getFullYear()).slice(-2) +
      String(date.getMonth() + 1).padStart(2, '0') +
      String(date.getDate()).padStart(2, '0');
    var randomPart = Math.random().toString(36).slice(2, 7).toUpperCase();
    return 'UQ-' + datePart + '-' + randomPart;
  }

  function buildSummary(reference, quoteUrl) {
    var lines = [
      'UNICARE PRODUCT QUOTATION REQUEST',
      'Reference: ' + reference,
      'Submitted from: ' + window.location.href.split('#')[0],
      '',
      'SELECTED PRODUCTS'
    ];

    items.forEach(function (item, index) {
      lines.push('');
      lines.push((index + 1) + '. ' + item.productTitle);
      if (displayVariantTitle(item.variantTitle)) lines.push('Option: ' + item.variantTitle);
      if (item.sku) lines.push('SKU: ' + item.sku);
      lines.push('Quantity: ' + clampQuantity(item.quantity));
      lines.push('Variant ID: ' + item.variantId);
      lines.push('Product: ' + window.location.origin + safeProductUrl(item.url));
    });

    lines.push('');
    if (quoteUrl) lines.push('Secure quote link: ' + quoteUrl);
    lines.push('No prices were displayed or submitted. Please review this request and prepare current pricing in a Shopify Draft Order.');
    return lines.join('\n');
  }

  function buildMessengerDemoSummary(reference) {
    var lines = [
      'Hello Unicare! I would like to request pricing for this product list.',
      '',
      'UNICARE QUOTE LIST — WEBSITE PREVIEW',
      'Demo reference: ' + reference,
      'Page: ' + window.location.href.split('#')[0],
      '',
      'SELECTED PRODUCTS'
    ];

    items.forEach(function (item, index) {
      lines.push('');
      lines.push((index + 1) + '. ' + item.productTitle);
      if (displayVariantTitle(item.variantTitle)) lines.push('Option: ' + item.variantTitle);
      if (item.sku) lines.push('SKU: ' + item.sku);
      lines.push('Quantity: ' + clampQuantity(item.quantity));
      lines.push('Product: ' + window.location.origin + safeProductUrl(item.url));
    });

    lines.push('');
    lines.push('Please send me the current pricing and availability for these items. Thank you!');
    return lines.join('\n');
  }

  function legacyCopyText(value) {
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        if (!document.execCommand('copy')) throw new Error('Copy was blocked.');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function copyText(value) {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(value).catch(function () {
        return legacyCopyText(value);
      });
    }

    return legacyCopyText(value);
  }

  function setMessengerHandoffStatus(message) {
    if (messengerDemoStatus) messengerDemoStatus.textContent = message;
    document.querySelectorAll('[data-messenger-handoff-status]').forEach(function (status) {
      status.textContent = message;
    });
  }

  function setQuoteIdStatus(message, isError) {
    if (!quoteIdStatus) return;
    quoteIdStatus.textContent = message;
    quoteIdStatus.classList.toggle('is-error', Boolean(isError));
  }

  function setSavedQuoteMessage(quoteId, message, isError) {
    var messageNode = drawer.querySelector('[data-saved-quote-message="' + quoteId + '"]');
    if (!messageNode) return;
    messageNode.textContent = message;
    messageNode.classList.toggle('is-error', Boolean(isError));
  }

  function surfaceApprovedCheckoutAfterUnlock() {
    if (!pricingUnlocked) return;

    try {
      var checkoutIntent = window.sessionStorage.getItem('unicare-approved-checkout-intent');
      var unlockedAt = parseInt(window.sessionStorage.getItem('unicare-pricing-just-unlocked'), 10) || 0;
      var recentlyUnlocked = unlockedAt > 0 && Date.now() - unlockedAt < 120000;
      var approvedQuote = savedQuotes.find(function (quote) {
        return quote.status === 'approved' && (!checkoutIntent || quote.quoteId === checkoutIntent);
      });

      if (!approvedQuote && checkoutIntent) {
        approvedQuote = savedQuotes.find(function (quote) { return quote.status === 'approved'; });
      }
      if (!approvedQuote || (!checkoutIntent && !recentlyUnlocked)) {
        if (unlockedAt && !recentlyUnlocked) window.sessionStorage.removeItem('unicare-pricing-just-unlocked');
        return;
      }

      window.sessionStorage.removeItem('unicare-approved-checkout-intent');
      window.sessionStorage.removeItem('unicare-pricing-just-unlocked');
      openDrawer();
      window.requestAnimationFrame(function () {
        var intendedCard = drawer.querySelector('[data-saved-quote="' + approvedQuote.quoteId + '"]');
        var intendedButton = drawer.querySelector('[data-quote-approved-checkout="' + approvedQuote.quoteId + '"]');
        if (intendedCard && typeof intendedCard.scrollIntoView === 'function') intendedCard.scrollIntoView({ block: 'start' });
        if (intendedButton) intendedButton.focus();
      });
    } catch (error) {}
  }

  function reconcileSavedQuotes(force) {
    if (!savedQuotes.length || !/^https:\/\//i.test(quoteApiUrl) || quoteStatusCheckInFlight) return;
    if (!force && Date.now() - lastQuoteStatusCheckAt < 60000) return;

    quoteStatusCheckInFlight = true;
    lastQuoteStatusCheckAt = Date.now();

    Promise.all(savedQuotes.map(function (quote) {
      return window.fetch(quoteApiUrl + '/api/quotes/' + encodeURIComponent(quote.quoteId), {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          'Accept': 'application/json',
          'X-Unicare-Quote-Client': quote.clientRequestId
        }
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (response.status === 404) return { quote: quote, remove: true };
          if (!response.ok) throw new Error(data.error || 'Quote status is temporarily unavailable.');
          return { quote: quote, data: data, remove: data.active === false || data.status === 'converted_to_order' };
        });
      }).catch(function () {
        return { quote: quote, failed: true };
      });
    })).then(function (results) {
      var removedCount = 0;
      savedQuotes = results.filter(function (result) {
        if (result.remove) removedCount += 1;
        return !result.remove;
      }).map(function (result) {
        if (!result.data) return result.quote;
        return normalizeSavedQuote({
          quoteId: result.data.quoteId,
          clientRequestId: result.quote.clientRequestId,
          status: result.data.status,
          revision: result.data.revision,
          items: result.data.items,
          changes: result.data.changes,
          staffNote: result.data.staffNote,
          approvedAt: result.data.approvedAt,
          approvalToken: result.data.approvalToken
        }) || result.quote;
      });
      saveSavedQuotes();
      renderItems();
      surfaceApprovedCheckoutAfterUnlock();

      var pendingQuoteId = pendingCheckoutQuoteId();
      if (pendingQuoteId && !savedQuotes.some(function (quote) { return quote.quoteId === pendingQuoteId; })) {
        clearPendingCheckout(pendingQuoteId);
      }

      results.filter(function (result) { return result.failed; }).forEach(function (result) {
        setSavedQuoteMessage(result.quote.quoteId, 'Could not refresh this quote right now. Its last saved details are still shown.', true);
      });
      if (removedCount) announce(removedCount + (removedCount === 1 ? ' completed quote was' : ' completed quotes were') + ' removed from this browser.');
    }).then(function () {
      quoteStatusCheckInFlight = false;
    });
  }

  function deleteSavedQuote(event, quoteId) {
    event.preventDefault();
    var quote = savedQuotes.find(function (candidate) { return candidate.quoteId === quoteId; });
    if (!quote) return;

    if (!window.confirm('Delete ' + quoteId + '? The quote ID will stop working and disappear from this browser.')) return;

    var deleteButton = event.target.closest('[data-quote-id-delete]');
    if (deleteButton) {
      deleteButton.disabled = true;
      deleteButton.textContent = 'Deleting…';
    }
    setSavedQuoteMessage(quoteId, 'Deleting quote…', false);

    window.fetch(quoteApiUrl + '/api/quotes/' + encodeURIComponent(quote.quoteId), {
      method: 'DELETE',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Accept': 'application/json',
        'X-Unicare-Quote-Client': quote.clientRequestId
      }
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (response.status === 404) return { deleted: true };
        if (response.status === 409 && data.status === 'converted_to_order') return { converted: true };
        if (!response.ok) throw new Error(data.error || 'The quote could not be deleted.');
        return { deleted: true };
      });
    }).then(function (result) {
      if (activeHandoff && activeHandoff.quoteId === quoteId) {
        activeHandoff = null;
        saveActiveHandoff();
      }
      removeSavedQuote(quoteId);
      renderItems();
      setQuoteIdStatus(
        result.converted
          ? 'This quote was already converted to an order and has been removed from this browser.'
          : quoteId + ' was deleted.',
        false
      );
      announce(result.converted ? 'Quote converted to an order.' : 'Saved quote deleted.');
    }).catch(function (error) {
      if (deleteButton) {
        deleteButton.disabled = false;
        deleteButton.textContent = 'Delete quote';
      }
      setSavedQuoteMessage(quoteId, error.message || 'The quote could not be deleted. Please try again.', true);
    });
  }

  function reviseSavedQuote(event, quoteId) {
    event.preventDefault();
    var quote = savedQuotes.find(function (candidate) { return candidate.quoteId === quoteId; });
    if (!quote || !quote.items.length) return;

    if (items.length && !window.confirm('Replace the current editable quote with the items from ' + quoteId + '?')) return;
    items = sanitizeStoredItems(quote.items);
    formMode = false;
    successMode = false;
    saveItems();
    renderItems();
    setQuoteIdStatus('Copied ' + quoteId + ' into a new editable quote. Add, remove, or change quantities, then create a new quote ID for staff review.', false);
    announce('Approved items copied into a new editable quote.');
    var firstItem = drawer.querySelector('[data-quote-item]');
    if (firstItem && typeof firstItem.scrollIntoView === 'function') firstItem.scrollIntoView({ block: 'start' });
  }

  function shareMessengerDemoQuote(event) {
    event.preventDefault();

    if (!items.length) {
      closeMessengerDemo(false);
      openDrawer(messengerDemoToggle);
      return;
    }

    var messengerUrl = safeMessengerRedirect(messengerDemo.getAttribute('data-messenger-url'));
    if (!messengerUrl) {
      setMessengerHandoffStatus('The Messenger link is not configured.');
      return;
    }

    messengerDemoReference = messengerDemoReference || 'DEMO-' + makeReference();
    copyText(buildMessengerDemoSummary(messengerDemoReference)).then(function () {
      setMessengerHandoffStatus('Copied! Opening Messenger…');
      announce('Quote list copied. Opening Messenger.');
      window.setTimeout(function () {
        window.location.assign(messengerUrl);
      }, 180);
    }).catch(function () {
      setMessengerHandoffStatus('Your browser blocked copying. Allow clipboard access, then try again. Messenger was not opened.');
    });
  }

  function makeClientRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'uq-client-' + Date.now() + '-' + Math.random().toString(36).slice(2, 12);
  }

  function formValue(name) {
    var field = quoteForm.querySelector('[name="' + name + '"]');
    return field ? String(field.value || '').trim() : '';
  }

  function messengerPayload() {
    clientRequestId = clientRequestId || makeClientRequestId();

    return {
      clientRequestId: clientRequestId,
      storefrontOrigin: window.location.origin,
      sourceUrl: window.location.href.split('#')[0],
      customer: {
        name: formValue('contact[name]'),
        email: formValue('contact[email]'),
        phoneOrMessenger: formValue('contact[Phone or Messenger]'),
        company: formValue('contact[Company or clinic]'),
        preferredContactMethod: formValue('contact[Preferred contact method]'),
        notes: formValue('contact[Customer notes]')
      },
      consent: Boolean(quoteForm.querySelector('[name="contact[Consent]"]:checked')),
      items: items.map(function (item) {
        return {
          type: item.type === 'custom' ? 'custom' : 'shopify_variant',
          itemKey: itemIdentity(item),
          productId: String(item.productId || ''),
          productTitle: String(item.productTitle || ''),
          variantId: String(item.variantId || ''),
          variantTitle: String(item.variantTitle || ''),
          sku: String(item.sku || ''),
          productUrl: window.location.origin + safeProductUrl(item.url),
          imageUrl: safeImageUrl(item.image),
          quantity: clampQuantity(item.quantity)
        };
      })
    };
  }

  function quoteIdPayload() {
    clientRequestId = clientRequestId || makeClientRequestId();

    return {
      clientRequestId: clientRequestId,
      storefrontOrigin: window.location.origin,
      sourceUrl: window.location.href.split('#')[0],
      items: items.map(function (item) {
        return {
          type: item.type === 'custom' ? 'custom' : 'shopify_variant',
          itemKey: itemIdentity(item),
          productId: String(item.productId || ''),
          productTitle: String(item.productTitle || ''),
          variantId: String(item.variantId || ''),
          variantTitle: String(item.variantTitle || ''),
          sku: String(item.sku || ''),
          productUrl: window.location.origin + safeProductUrl(item.url),
          imageUrl: safeImageUrl(item.image),
          quantity: clampQuantity(item.quantity)
        };
      })
    };
  }

  function safeMessengerRedirect(value) {
    try {
      var url = new URL(value);
      if (url.protocol !== 'https:' || url.hostname !== 'm.me') return null;
      return url.href;
    } catch (error) {
      return null;
    }
  }

  function safeCheckoutUrl(value) {
    try {
      var url = new URL(String(value || ''));
      var hostname = url.hostname.toLowerCase();
      var trustedHost = hostname === 'unicaredentalsupply.com' ||
        hostname === 'www.unicaredentalsupply.com' ||
        hostname === 'checkout.shopify.com' ||
        /\.myshopify\.com$/.test(hostname);
      return url.protocol === 'https:' && trustedHost ? url.href : null;
    } catch (error) {
      return null;
    }
  }

  function setSubmitting(isSubmitting) {
    var submitButton = quoteForm.querySelector('[data-quote-submit]');
    if (!submitButton) return;

    if (!submitButton.getAttribute('data-idle-label')) {
      submitButton.setAttribute('data-idle-label', submitButton.textContent.trim());
    }

    submitButton.disabled = isSubmitting;
    submitButton.textContent = isSubmitting ? 'Preparing Messenger…' : submitButton.getAttribute('data-idle-label');
  }

  function showFormError(message) {
    var error = quoteForm.querySelector('[data-quote-form-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
    error.focus();
  }

  function createQuoteId(event) {
    event.preventDefault();

    if (!quoteIdHandoffEnabled || !/^https:\/\//i.test(quoteApiUrl)) {
      setQuoteIdStatus('The preview quote ID service is not connected yet.', true);
      return;
    }

    if (!items.length) {
      setQuoteIdStatus('Add at least one product before creating a quote ID.', true);
      return;
    }

    quoteIdCreateButton.disabled = true;
    quoteIdCreateButton.textContent = 'Saving quote…';
    setQuoteIdStatus('', false);

    window.fetch(quoteApiUrl + '/api/quotes', {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(quoteIdPayload())
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.error || 'The quote service could not save your quote list.');
        return data;
      });
    }).then(function (data) {
      var returnedQuoteId = String(data.quoteId || '');
      if (!validQuoteId(returnedQuoteId)) {
        throw new Error('The quote service returned an invalid quote ID.');
      }

      var requestId = clientRequestId;
      var submittedItems = items.slice();
      var savedQuote = upsertSavedQuote(data, requestId, submittedItems);
      if (!savedQuote) throw new Error('The quote service returned incomplete saved quote details.');

      activeHandoff = { quoteId: savedQuote.quoteId, step: 2 };
      saveActiveHandoff();
      items = [];
      clientRequestId = null;
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
      renderItems();
      setQuoteIdStatus('', false);
      announce('Your quote ID is ' + savedQuote.quoteId + '.');
      if (handoffCopyButton) handoffCopyButton.focus();
    }).catch(function (error) {
      quoteIdCreateButton.disabled = false;
      quoteIdCreateButton.textContent = 'Try creating quote ID again';
      setQuoteIdStatus(error.message || 'The quote could not be saved. Please try again.', true);
    });
  }

  function copyQuoteIdAndOpenMessenger(event, quoteId) {
    event.preventDefault();

    if (!quoteMessengerUrl) {
      setSavedQuoteMessage(quoteId, 'The Unicare Messenger link is not configured.', true);
      return;
    }

    var copyButton = event.target.closest('[data-quote-id-copy], [data-quote-handoff-copy]');
    if (copyButton) {
      copyButton.disabled = true;
      copyButton.textContent = 'Copying…';
    }
    copyText(quoteId).then(function () {
      if (activeHandoff && activeHandoff.quoteId === quoteId) {
        activeHandoff.step = 3;
        saveActiveHandoff();
        renderItems();
      }
      setSavedQuoteMessage(quoteId, 'Copied! Opening Messenger…', false);
      announce('Quote ID copied. Opening Messenger.');
      window.setTimeout(function () {
        window.location.assign(quoteMessengerUrl);
      }, 180);
    }).catch(function () {
      if (copyButton) {
        copyButton.disabled = false;
        copyButton.textContent = 'Copy ID and open Messenger';
      }
      setSavedQuoteMessage(quoteId, 'Copy was blocked. Select the quote ID above and copy it manually.', true);
    });
  }

  function finishMessengerHandoff(event) {
    event.preventDefault();
    activeHandoff = null;
    saveActiveHandoff();
    renderItems();
    announce('Messenger handoff completed. You can start another quote.');
  }

  function shopifyRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function shopifyJson(path, options, fallbackMessage) {
    return window.fetch(shopifyRoot() + path, options || {}).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || fallbackMessage);
        return data;
      });
    });
  }

  function resetApprovedCart() {
    return shopifyJson('cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }, 'Shopify could not reset the cart.').then(function () {
      return shopifyJson('cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Unicare Quote ID': '',
            '_unicare_approved_quote_id': '',
            '_unicare_approved_quote_token': '',
            '_unicare_approved_quote_revision': ''
          }
        })
      }, 'Shopify could not reset the quote approval.');
    });
  }

  function syncApprovedQuoteToCart(quote, approvedData) {
    var approvedItems = Array.isArray(approvedData.items) ? approvedData.items : [];
    if (!approvedItems.length) return Promise.reject(new Error('This approved quote has no checkout items.'));
    if (approvedItems.some(function (item) { return item.type === 'custom'; })) {
      return Promise.reject(new Error('The secure Shopify checkout for this custom quote is not available yet. Ask Unicare staff to re-approve it.'));
    }

    return resetApprovedCart().then(function () {
      return shopifyJson('cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: approvedItems.map(function (item) {
            return { id: String(item.variantId), quantity: clampQuantity(item.quantity) };
          })
        })
      }, 'One or more approved products are no longer available at the reviewed quantity.');
    }).then(function () {
      return shopifyJson('cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Unicare Quote ID': quote.quoteId,
            '_unicare_approved_quote_id': quote.quoteId,
            '_unicare_approved_quote_token': approvedData.approvalToken,
            '_unicare_approved_quote_revision': String(approvedData.revision || 0)
          }
        })
      }, 'Shopify could not attach the quote approval to the cart.');
    }).then(function () {
      return shopifyJson('cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }, 'Shopify could not verify the approved cart.');
    }).then(function (cart) {
      var expected = {};
      approvedItems.forEach(function (item) {
        expected[String(item.variantId)] = (expected[String(item.variantId)] || 0) + clampQuantity(item.quantity);
      });
      var actual = {};
      (cart.items || []).forEach(function (item) {
        var variantId = String(item.variant_id || item.id || '');
        actual[variantId] = (actual[variantId] || 0) + clampQuantity(item.quantity);
      });
      var expectedIds = Object.keys(expected).sort();
      var actualIds = Object.keys(actual).sort();
      var matches = expectedIds.length === actualIds.length && expectedIds.every(function (variantId, index) {
        return variantId === actualIds[index] && expected[variantId] === actual[variantId];
      });
      var cartAttributes = cart && cart.attributes ? cart.attributes : {};
      var cartQuoteId = String(cartAttributes['_unicare_approved_quote_id'] || cartAttributes['Unicare Quote ID'] || '').toUpperCase();
      var cartRevision = String(cartAttributes['_unicare_approved_quote_revision'] || '');
      var expectedRevision = String(approvedData.revision || 0);
      if (!matches || cartQuoteId !== quote.quoteId || cartRevision !== expectedRevision) {
        throw new Error('Shopify could not reproduce the exact selected quote. No checkout was opened.');
      }
      window.location.assign(
        shopifyRoot() + 'cart?unicare_quote=' + encodeURIComponent(quote.quoteId) +
        '&revision=' + encodeURIComponent(expectedRevision) +
        '&refresh=' + Date.now()
      );
    });
  }

  function checkoutApprovedQuote(event, quoteId) {
    event.preventDefault();
    var quote = savedQuotes.find(function (candidate) { return candidate.quoteId === quoteId; });
    if (!quote) return;

    if (!pricingUnlocked) {
      try { window.sessionStorage.setItem('unicare-approved-checkout-intent', quoteId); } catch (error) {}
      closeDrawer();
      var pricingButton = document.querySelector('[data-pricing-open]');
      if (pricingButton) pricingButton.click();
      return;
    }

    if (!quote.approvalToken) {
      lastQuoteStatusCheckAt = 0;
      openDrawer(event.target.closest('.quote-floating-cta'));
      setSavedQuoteMessage(quoteId, 'Refreshing the checkout approval. Please press checkout again in a moment.', false);
      reconcileSavedQuotes(true);
      return;
    }

    if (approvedCheckoutInFlight) {
      setSavedQuoteMessage(quoteId, 'Another approved quote is already being prepared. Please wait a moment.', false);
      return;
    }

    approvedCheckoutInFlight = quoteId;

    var checkoutButton = event.target.closest('[data-quote-approved-checkout], [data-approved-quote-launcher], .quote-floating-cta');
    var checkoutButtonLabel = checkoutButton && checkoutButton.querySelector('[data-quote-floating-label]');
    drawer.querySelectorAll('[data-quote-approved-checkout]').forEach(function (button) {
      button.disabled = true;
    });
    if (checkoutButton) {
      checkoutButton.disabled = true;
      if (checkoutButtonLabel) {
        checkoutButtonLabel.textContent = 'Preparing approved cart…';
      } else {
        checkoutButton.textContent = 'Preparing approved cart…';
      }
    }
    setSavedQuoteMessage(quoteId, 'Rechecking approval and availability…', false);

    window.fetch(quoteApiUrl + '/api/quotes/' + encodeURIComponent(quote.quoteId) + '/checkout', {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Accept': 'application/json',
        'X-Unicare-Quote-Client': quote.clientRequestId,
        'X-Unicare-Quote-Approval': quote.approvalToken
      }
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.error || 'This quote is no longer approved for checkout.');
        return data;
      });
    }).then(function (data) {
      var refreshedQuote = upsertSavedQuote(data, quote.clientRequestId, quote.items);
      if (!refreshedQuote || refreshedQuote.status !== 'approved' || !refreshedQuote.approvalToken) {
        throw new Error('This quote is no longer approved for checkout.');
      }
      var customCheckoutUrl = safeCheckoutUrl(data.checkoutUrl || refreshedQuote.checkoutUrl);
      if (customCheckoutUrl) {
        rememberPendingCheckout(refreshedQuote.quoteId);
        window.location.assign(customCheckoutUrl);
        return null;
      }
      return syncApprovedQuoteToCart(refreshedQuote, data);
    }).catch(function (error) {
      approvedCheckoutInFlight = '';
      resetApprovedCart().catch(function () {});
      renderItems();
      if (checkoutButton) checkoutButton.disabled = false;
      openDrawer(checkoutButton);
      setSavedQuoteMessage(quoteId, error.message || 'The approved quote could not be prepared for checkout.', true);
    });
  }

  function submitShopifyEmailBackup(reference, quoteUrl) {
    var referenceField = quoteForm.querySelector('[data-quote-reference]');
    var summaryField = quoteForm.querySelector('[data-quote-summary]');
    referenceField.value = reference;
    summaryField.value = buildSummary(reference, quoteUrl);

    var action = quoteForm.getAttribute('action').split('#')[0];
    var request = window.fetch(action, {
      method: 'POST',
      body: new FormData(quoteForm),
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' },
      keepalive: true
    });

    var timeout = new Promise(function (resolve) {
      window.setTimeout(resolve, 3500);
    });

    return Promise.race([request, timeout]).catch(function () {
      return null;
    });
  }

  function createMessengerQuote(event) {
    event.preventDefault();
    setSubmitting(true);

    window.fetch(quoteApiUrl + '/api/quotes', {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(messengerPayload())
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.error || 'The quote service could not save your request.');
        return data;
      });
    }).then(function (data) {
      var messengerUrl = safeMessengerRedirect(data.messengerUrl);
      if (!validQuoteId(data.quoteId) || !data.quoteUrl || !messengerUrl) {
        throw new Error('The quote service returned an incomplete Messenger handoff.');
      }

      var backup = data.created === false ? Promise.resolve() : submitShopifyEmailBackup(data.quoteId, data.quoteUrl);
      return backup.then(function () {
        upsertSavedQuote(data, clientRequestId, items.slice());
        items = [];
        clientRequestId = null;
        try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
        renderItems();
        window.location.assign(messengerUrl);
      });
    }).catch(function (error) {
      setSubmitting(false);
      showFormError(error.message || 'We could not continue to Messenger. Please try again.');
    });
  }

  function prepareForm(event) {
    if (!items.length) {
      event.preventDefault();
      var error = quoteForm.querySelector('[data-quote-form-error]');
      error.textContent = 'Please add at least one product before sending your request.';
      error.hidden = false;
      formMode = false;
      renderItems();
      return;
    }

    var existingError = quoteForm.querySelector('[data-quote-form-error]');
    if (existingError) existingError.hidden = true;

    if (messengerIntegrationEnabled) {
      createMessengerQuote(event);
      return;
    }

    var referenceField = quoteForm.querySelector('[data-quote-reference]');
    var summaryField = quoteForm.querySelector('[data-quote-summary]');
    var submitButton = quoteForm.querySelector('[data-quote-submit]');
    var reference = referenceField.value || makeReference();

    referenceField.value = reference;
    summaryField.value = buildSummary(reference, '');

    var action = quoteForm.getAttribute('action').split('#')[0];
    quoteForm.setAttribute('action', action + (action.indexOf('?') === -1 ? '?' : '&') + 'quote_request=1#QuoteRequestForm');

    submitButton.disabled = true;
    submitButton.textContent = 'Sending request…';
  }

  function showForm() {
    if (!items.length) return;
    formMode = true;
    applyPanelState();
    var firstField = formPanel.querySelector('input:not([type="hidden"])');
    if (firstField) firstField.focus();
  }

  function hideForm() {
    formMode = false;
    applyPanelState();
    var requestButton = drawer.querySelector('[data-quote-show-form]');
    if (requestButton) requestButton.focus();
  }

  function switchProductImage(select) {
    var selected = select.options[select.selectedIndex];
    var imageId = selected && selected.getAttribute('data-image-id');
    var section = select.closest('[data-section-type="product-template"]');
    if (!section) return;

    var visiblePrice = section.querySelector('[data-quote-visible-price]');
    var priceLabel = selected && selected.getAttribute('data-price-label');
    if (visiblePrice && priceLabel) visiblePrice.textContent = priceLabel;
    if (!imageId) return;

    section.querySelectorAll('[id^="productPhotoWrapper-"]').forEach(function (wrapper) {
      wrapper.classList.toggle('hide', wrapper.getAttribute('data-image-id') !== imageId);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var quoteIdCreate = target.closest('[data-quote-id-create]');
    var quoteIdCopy = target.closest('[data-quote-id-copy]');
    var handoffCopy = target.closest('[data-quote-handoff-copy]');
    var handoffDone = target.closest('[data-quote-handoff-done]');
    var quoteIdDelete = target.closest('[data-quote-id-delete]');
    var quoteIdRevise = target.closest('[data-quote-id-revise]');
    var approvedCheckout = target.closest('[data-quote-approved-checkout]');
    var refreshSavedQuotes = target.closest('[data-saved-quotes-refresh]');
    var approvedQuotesJumpButton = target.closest('[data-approved-quotes-jump]');
    var messengerToggleButton = target.closest('[data-messenger-demo-toggle]');
    var messengerCloseButton = target.closest('[data-messenger-demo-close]');
    var messengerShareButton = target.closest('[data-messenger-demo-share]');
    var messengerQuoteButton = target.closest('[data-messenger-demo-quote]');
    var addButton = target.closest('[data-quote-add]');
    var openButton = target.closest('[data-quote-open]');
    var closeButton = target.closest('[data-quote-close]');
    var increaseButton = target.closest('[data-quote-increase]');
    var decreaseButton = target.closest('[data-quote-decrease]');
    var productIncreaseButton = target.closest('[data-quote-product-increase]');
    var productDecreaseButton = target.closest('[data-quote-product-decrease]');
    var removeButton = target.closest('[data-quote-remove]');
    var showFormButton = target.closest('[data-quote-show-form]');
    var hideFormButton = target.closest('[data-quote-hide-form]');
    var clearButton = target.closest('[data-quote-clear]');
    var thumbnail = target.closest('.product-photo-thumb');

    if (quoteIdCreate) {
      createQuoteId(event);
    } else if (handoffCopy && activeHandoff) {
      copyQuoteIdAndOpenMessenger(event, activeHandoff.quoteId);
    } else if (handoffDone) {
      finishMessengerHandoff(event);
    } else if (quoteIdRevise) {
      reviseSavedQuote(event, quoteIdRevise.getAttribute('data-quote-id-revise'));
    } else if (quoteIdCopy) {
      copyQuoteIdAndOpenMessenger(event, quoteIdCopy.getAttribute('data-quote-id-copy'));
    } else if (quoteIdDelete) {
      deleteSavedQuote(event, quoteIdDelete.getAttribute('data-quote-id-delete'));
    } else if (approvedCheckout) {
      checkoutApprovedQuote(event, approvedCheckout.getAttribute('data-quote-approved-checkout'));
    } else if (refreshSavedQuotes) {
      event.preventDefault();
      lastQuoteStatusCheckAt = 0;
      reconcileSavedQuotes(true);
    } else if (approvedQuotesJumpButton) {
      jumpToApprovedCheckout(event);
    } else if (messengerToggleButton) {
      event.preventDefault();
      toggleMessengerDemo(messengerToggleButton);
    } else if (messengerCloseButton) {
      event.preventDefault();
      closeMessengerDemo();
    } else if (messengerShareButton) {
      shareMessengerDemoQuote(event);
    } else if (messengerQuoteButton) {
      event.preventDefault();
      closeMessengerDemo(false);
      openDrawer(messengerDemoToggle);
    } else if (addButton) {
      event.preventDefault();
      addItem(addButton);
    } else if (openButton) {
      event.preventDefault();
      openDrawer(openButton);
    } else if (closeButton || target === overlay) {
      event.preventDefault();
      closeDrawer();
    } else if (increaseButton) {
      changeQuantity(increaseButton.getAttribute('data-quote-increase'), 1);
    } else if (decreaseButton) {
      changeQuantity(decreaseButton.getAttribute('data-quote-decrease'), -1);
    } else if (productIncreaseButton) {
      event.preventDefault();
      changeProductQuantity(productIncreaseButton, 1);
    } else if (productDecreaseButton) {
      event.preventDefault();
      changeProductQuantity(productDecreaseButton, -1);
    } else if (removeButton) {
      removeItem(removeButton.getAttribute('data-quote-remove'));
    } else if (showFormButton) {
      showForm();
    } else if (hideFormButton) {
      hideForm();
    } else if (clearButton && window.confirm('Remove all products from your quote list?')) {
      items = [];
      formMode = false;
      saveItems();
      renderItems();
      announce('Your quote list was cleared.');
    } else if (thumbnail) {
      var imageSection = thumbnail.closest('[data-section-type="product-template"]');
      var selectedImageId = thumbnail.getAttribute('data-image-id');
      if (imageSection && selectedImageId) {
        event.preventDefault();
        imageSection.querySelectorAll('[id^="productPhotoWrapper-"]').forEach(function (wrapper) {
          wrapper.classList.toggle('hide', wrapper.getAttribute('data-image-id') !== selectedImageId);
        });
      }
    }

    if (messengerDemo && messengerDemoPanel && !messengerDemoPanel.hidden && !messengerDemo.contains(target)) {
      closeMessengerDemo(false);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-quote-item-quantity]')) {
      setQuantity(event.target.getAttribute('data-quote-item-quantity'), event.target.value);
    } else if (event.target.matches('[data-quote-variant]')) {
      switchProductImage(event.target);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && messengerDemoPanel && !messengerDemoPanel.hidden) {
      closeMessengerDemo();
      return;
    }

    if (!drawer.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }

    if (event.key === 'Tab') {
      var focusable = Array.prototype.slice.call(drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return !element.hidden && element.offsetParent !== null;
      });

      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  if (quoteForm) quoteForm.addEventListener('submit', prepareForm);

  window.addEventListener('focus', function () {
    reconcileSavedQuotes(false);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) reconcileSavedQuotes(false);
  });

  function watchPendingCheckoutCompletion() {
    if (!pendingCheckoutQuoteId()) return;

    [2500, 6000, 12000, 25000, 45000, 80000].forEach(function (delay) {
      window.setTimeout(function () {
        if (!pendingCheckoutQuoteId()) return;
        lastQuoteStatusCheckAt = 0;
        reconcileSavedQuotes(true);
      }, delay);
    });
  }

  var requestParams = new URLSearchParams(window.location.search);
  var quoteSubmission = requestParams.get('quote_request') === '1';
  var postedSuccessfully = drawer.querySelector('[data-quote-posted-successfully]');
  var formErrors = quoteForm && quoteForm.querySelector('.errors');

  if (quoteSubmission && postedSuccessfully) {
    items = [];
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
    successMode = true;
    renderItems();
    openDrawer();
  } else {
    renderItems();
    reconcileSavedQuotes(true);
    watchPendingCheckoutCompletion();
    surfaceApprovedCheckoutAfterUnlock();
    if (quoteSubmission && formErrors) {
      formMode = true;
      renderItems();
      openDrawer();
    }
  }
})();
